import { useCallback } from 'react';
import { OrderItemClaim } from '@mews-commander/data-access';
import { getOrderItemMultiplier } from '@mews-commander/legacy-entities/src/ducks/orderItemNew';
import { useClaimOrderItemsMutation } from '../mutations/claimOrderItemsMutation';
import { ProductData } from '../types';

export const useToggleClaimAll = (productData: ProductData[], allClaimed: boolean) => {
    const claimOrderItemsMutation = useClaimOrderItemsMutation();

    const toggleClaimAll = useCallback<React.MouseEventHandler<HTMLButtonElement>>(() => {
        const claim = !allClaimed;

        const orderItemClaims: OrderItemClaim[] = productData.flatMap(({ orderItems }) =>
            orderItems.map((orderItem) => ({
                orderItemId: orderItem.id,
                claimedCount: claim ? getOrderItemMultiplier(orderItem) : 0,
            }))
        );

        claimOrderItemsMutation.mutate({ orderItemClaims });
    }, [allClaimed, productData, claimOrderItemsMutation]);

    return {
        toggleClaimAll,
        isLoading: claimOrderItemsMutation.isPending,
    };
};
